<!-- @format -->

<section
	id="reviews-responsive-summary"
	class="reviews-responsive-summary hmf-display-flex hmf-flex-column hmf-flex-m-row"
	[attr.itemscope]="renderSEO() ? true : undefined"
	[attr.itemprop]="renderSEO() ? 'aggregateRating' : undefined"
	[attr.itemtype]="renderSEO() ? 'https://schema.org/AggregateRating' : undefined"
	[ngClass]="{
		'hmf-px-s': isDrawer(),
		'hmf-pl-l-s': !isDrawer()
	}">
	@if (renderSEO() && productName()) {
		<div
			itemscope
			itemprop="itemReviewed"
			itemtype="https://schema.org/IndividualProduct">
			<meta
				itemprop="name"
				content="{{ productName() }}" />
		</div>
	}
	<div
		class="rating-information hmf-display-flex hmf-flex-column hmf-align-items-center hmf-span-s-12 hmf-span-m-4"
		[ngClass]="{
			'hmf-mr-xxxxl hmf-ml-m-xxs': !isDrawer(),
			slim: !isDrawer() && (!percentage() || !rating())
		}">
		<div class="rating-information-inner-container hmf-display-flex hmf-mb-m-xs hmf-mx-auto hmf-px-xxs">
			@if (rating()) {
				<div>
					<span class="reviews-responsive-summary-rating-number hmf-header-bold-l hmf-m-0" data-nosnippet>
						{{ rating() | starRatingNumber }}
					</span>
				</div>
				@if (renderSEO()) {
					<meta
						itemprop="ratingValue"
						[attr.content]="rating() | starRatingNumber" />
				}
				<product-reviews-review-stars [rating]="rating()" [options]="starsOptions()"></product-reviews-review-stars>
			}
			@if (percentage()) {
				<div>
					<span class="reviews-responsive-summary-percentage-number hmf-m-0 hmf-header-bold-l" data-nosnippet>
						{{ percentage() | number: '1.0-0' }}%
					</span>
				</div>
				<div class="hmf-display-flex hmf-align-items-center">
					<span class="hmf-subheader-m hmf-m-0">Recommended</span>
				</div>
			}
		</div>
		@if (renderSEO() && overallRatingRange()) {
			<meta
				itemprop="bestRating"
				content="{{ overallRatingRange() }}" />
		}
		<p
			class="reviews-responsive-summary-count-number hmf-body-m hmf-mb-0 hmf-mt-0 hmf-mt-xxs hmf-mt-m-0"
			data-nosnippet>
			{{ count() | number: '1.0-1' }} Reviews
		</p>
		@if (renderSEO()) {
			<meta
				itemprop="reviewCount"
				[attr.content]="count()" />
		}
	</div>

	<product-reviews-secondary-rating
		class="secondary-ratings"
		[ngClass]="{
			'hmf-col hmf-span-s-12 hmf-span-m-5 hmf-mr-m-m hmf-ml-m-m hmf-mr-l-xl hmf-px-m-xxs':
				isDrawer()
		}">
	</product-reviews-secondary-rating>

	@if (isDrawer()) {
		<product-reviews-review-button
			class="write-a-review-button hmf-mt-m hmf-mt-m-0 hmf-pl-s hmf-span-12 hmf-span-m-4 hmf-flex hmf-flex-row hmf-justify-content-center hmf-justify-content-m-flex-end"
			[label]="writeAReviewLabel()"
			[type]="writeAReviewType()"
			[isDrawer]="true">
		</product-reviews-review-button>
	}
</section>
